import { useUser } from '../context/UserContext';

/**
 * Returns permission flags for demo vs admin users.
 *
 * Demo users have read-only access to most of the app, but can:
 * - Create and edit job schedules
 * - Update jobs
 * - View invoices and RCTIs
 *
 * Admin users retain full access.
 */
export const useDemoPermissions = () => {
  const { userInfo } = useUser();
  const isDemo = userInfo?.userType === 'demo';

  return {
    isDemo,
    canWrite: !isDemo,       // Add/Edit for most entities (franchisees, clients, households, etc.)
    showUtilities: !isDemo,  // Utilities nav item and page
    showSettings: !isDemo,   // Settings nav item and page
    showXero: !isDemo,       // Xero-related pages
    showAllowedEmails: !isDemo, // Allowed emails page
  };
};

export default useDemoPermissions;
